import React from 'react';
import Loading from '@gp/components/Loading';
import MetricsCard2 from '@gp/pages/StudioDashboard/StudioOverall/components/MetricsCard2';
import TotalStudioCountsCard from './components/TotalStudioCountsCard';
import ActualBudgetCompletionCard from './components/ActualBudgetCompletionCard';
import TotalFulltimeEmployeeCard from './components/TotalFulltimeEmployeeCard';
import useKeyMetrics from './useKeyMetrics';
// import { getValidDate } from '@gp/utils/common';
import { formatMilestoneDateByStatus } from '@gp/utils/milestone';
import { FIELDS1, FIELD_NAMES } from '@gp/utils/metricTips';

import './index.scss';

import DEFAULT_STUDIO_ICON from '@gp/assets/svg/company-default.svg';
import FileIcon from '@gp/assets/svg/gameInformation/file.svg';
import GameIcon from '@gp/assets/svg/gameInformation/game.svg';
import defaultGameIcon from '@/pages/dashboard/assets/svg/mobile-game-default.svg';

const KeyMetrics: React.FC<IStudioOverallOverviewKeyMetricProps> = (props) => {
  const {
    isLoading: isLoadingProps,
    // commonData,
  } = props;

  const {
    isLoading: isLoadingInner,
    totalStudioCounts,
    newlyAcquiredCounts,
    numberReleasesThisYear,
    grossRevenueYTM,
    profitYTM,
    totalFulltimeEmployee,
  } = useKeyMetrics();

  const isLoading = isLoadingProps || isLoadingInner;

  return (
    <div className="gp-common-card">
      {isLoading && <Loading loading style={{ height: 350 }} />}
      {isLoading || (
        <div className="dbg-studio-overall-overview-key-metrics">
          <ul className="dbg-studio-overall-card-list">
            <li className="dbg-studio-overall-card-item">
              <TotalStudioCountsCard total={totalStudioCounts?.total || 0} details={totalStudioCounts?.details || []} />
            </li>
            <li className="dbg-studio-overall-card-item">
              <MetricsCard2
                isTitleMultipleLinesTextBubble
                multipleLinesTextFields={FIELDS1}
                multipleLinesTextFieldNames={FIELD_NAMES}
                multipleLinesTextData={{
                  definition: 'Studios acquired in past 12 months.',
                  source: 'Mergers and Acquisitions Team (M&A)',
                  updateCadence: 'Ad hoc, update when acquisition completed',
                }}
                title="Newly Acquired Studio Counts"
                icon={<img src={FileIcon} />}
                value={newlyAcquiredCounts?.value}
                logos={newlyAcquiredCounts?.logos}
                defaultLogo={DEFAULT_STUDIO_ICON}
                getBubbleMsg={(msg: any) => (
                  <div className="dbg-studio-overall-logo-bubble">
                    <div>{msg?.name ? `New Acquired: ${msg?.name}` : '-'}</div>
                    {/* <div className="dbg-studio-overall-logo-bubble-time">2024-01-02</div> */}
                  </div>
                )}
              />
            </li>
            <li className="dbg-studio-overall-card-item">
              <MetricsCard2
                // title={`${getValidDate(commonData?.dataTime, 'YYYY')} Releases`}
                title="Releases this year"
                icon={<img src={GameIcon} />}
                value={numberReleasesThisYear?.value}
                logos={numberReleasesThisYear?.logos}
                defaultLogo={defaultGameIcon}
                getBubbleMsg={(msg: any) => {
                  const date = msg?.date || '';
                  const dateConfirm = msg?.dateConfirm || '';
                  const dateFormatted = formatMilestoneDateByStatus(date, dateConfirm);

                  return (
                    <div className="dbg-studio-overall-logo-bubble">
                      <div>{msg?.name || '-'}</div>
                      <div className="dbg-studio-overall-logo-bubble-time">{dateFormatted}</div>
                    </div>
                  );
                }}
                isModalShowItemDate
                dateFormatter={(data) => {
                  // @ts-ignore
                  const { date, dateConfirm } = data || {};
                  return formatMilestoneDateByStatus(date, dateConfirm);
                }}
              />
            </li>
            <li className="dbg-studio-overall-card-item">
              <ActualBudgetCompletionCard
                title="Gross Revenue YTM"
                titleTipsCfg={{
                  definition: `
                    Actual total sales amount to the month.
                    <br />
                    Noted: This amount does not deduct steam/Epic platform share, and also include the sales amount of retail activation code (e.g. Humble Bundle, Heybox, etc.).
                  `,
                  source: 'Studio Reporting Package',
                  updateCadence: 'Monthly',
                }}
                {...grossRevenueYTM}
              />
            </li>
            <li className="dbg-studio-overall-card-item">
              <ActualBudgetCompletionCard
                title="Profit YTM"
                titleTipsCfg={{
                  definition:
                    'Net profit to the month, excluding all below line items, such as interest expenses and taxes.',
                  source: 'Studio Reporting Package',
                  updateCadence: 'Monthly',
                }}
                {...profitYTM}
              />
            </li>
            <li className="dbg-studio-overall-card-item">
              <TotalFulltimeEmployeeCard {...totalFulltimeEmployee} />
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default React.memo(KeyMetrics);
